export class TypologieAdresse {
  constructor(
    public idTypologieAdresse: number,
    public libelleLong: string,
  ) { }
}
